import { Button, Typography } from '@cobliteam/ui/components';
import { cn } from '@cobliteam/ui/utils';
import type React from 'react';
import * as styles from './styles';

export interface ControlButtonProps {
  Icon?: JSX.Element;
  text?: string;
  selected?: boolean;
  disabled?: boolean;
  noHover?: boolean;
  textClassName?: string;
  onClick: () => void;
  children?: React.ReactNode;
  className?: string;
}

export const ControlButton: React.FC<ControlButtonProps> = ({ Icon, text, selected, disabled, noHover, textClassName, onClick, children, className }) => {
  const handleClick = disabled || selected ? undefined : onClick;

  return (
    <Button
      startIcon={Icon}
      variant='outlined'
      size='sm'
      className={cn(
        'border-gray-light p-0 text-gray-dark hover:border-gray-light',
        selected || disabled ? 'border-gray-4 bg-white text-gray-light hover:text-gray-light' : 'bg-white',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        noHover ? '' : 'hover:bg-gray-lightest',
        styles.controlButton,
        className
      )}
      onClick={handleClick}
    >
      {text && (
        <Typography variant='text-sm' className={cn(styles.controlButtonText, selected ? 'text-primary' : 'text-gray-dark', textClassName)}>
          {text}
        </Typography>
      )}
      {children}
    </Button>
  );
};
